require('../../vendor/owl.carousel.min');

// Fixed current slide index https://github.com/OwlCarousel2/OwlCarousel2/issues/1203
const getOwlCurrentItemIndex = (event, loop) => {
    if (loop) {
        let current = (event.item.index + 1) - event.relatedTarget._clones.length / 2;
        let itemsCount = event.item.count;

        if (current > itemsCount || current == 0) {
            current = itemsCount - (current % itemsCount);
        }

        return current - 1;
    }

    return event.item.index;
}

function init() {
    singlePostCarousel()

    contentCarousel()

    relatedPostsCarousel()
}

function singlePostCarousel() {
    // Looped or not?
    const loopEnabled = $('.post-header-slider .owl-carousel .item').length > 1;

    // Change slide index on carousel scrolling
    const replaceNumeration = (event, navInner) => {
        if (event.item.count > 1) {
            navInner.text(`${getOwlCurrentItemIndex(event, loopEnabled) + 1} of ${event.item.count}`);
        }
    }

    // Initialize carousel
    $('.post-header-slider .owl-carousel').owlCarousel({
        loop: loopEnabled,
        items: 1,
        autoWidth: true,
        nav: true,
        navText: ["Previous", "Next"],
        navElement: "button",
        touchDrag: false,
        mouseDrag: false,
        responsive: {
            0: {
                items: 1,
                autoWidth: false
            },
            768: {
                items: 1,
            }
        },
        onInitialized: function (event) {
            // Append numeric indication and replace text on every slide change

            const navInner = $('<div class="slider-numeration"/>');
            const slider = $(event.currentTarget);

            slider.find('.owl-nav').prepend(navInner);

            replaceNumeration(event, navInner);
            slider.on('changed.owl.carousel', event => {
                replaceNumeration(event, navInner);
            })
        }
    });
}

function contentCarousel() {
    $('.post-content-slider').owlCarousel({
        loop: true,
        nav: true,
        navText: ["Previous", "Next"],
        navElement: "button",
        items: 1,
        touchDrag: true,
        mouseDrag: false,
        responsive: {
            0: {
                autoWidth: false
            },
            576: {
                autoWidth: true
            }
        }
    });
}

function relatedPostsCarousel() {
    const related = $('.related-grid-items');

    let inited = false;

    run();

    $(window).on("resize", run);

    function run() {
        if ($(window).width() < 768) {
            if (!inited) {
                initCarousel();
                inited = true;
            }
        } else if (inited) {
            destroyCarousel();
            inited = false;
        }
    }

    function initCarousel() {
        related.owlCarousel({
            loop: false,
            nav: false,
            touchDrag: true,
            mouseDrag: false,
            items: 2,
            autoWidth: true,
            responsive: {
                0: {
                    items: 1,
                    autoWidth: true,
                },
                576: {
                    items: 2,
                    autoWidth: false,
                }
            },
            onInitialized: function (event) {
                const slider = $(event.currentTarget);

                const currentItemIndex = getOwlCurrentItemIndex(event, false)
                let hasBeenScrolledToLatest = event.item.count > 1 && currentItemIndex > 0

                slider.on('changed.owl.carousel', event => {
                    const currentItem = getOwlCurrentItemIndex(event, false) + 1

                    if (currentItem === event.item.count) {
                        slider.addClass('scrolled-to-latest')
                        hasBeenScrolledToLatest = true
                    } else if (hasBeenScrolledToLatest) {
                        slider.removeClass('scrolled-to-latest')
                        hasBeenScrolledToLatest = false
                    }
                })

                // Fixes carousel auto width
                event.relatedTarget.coordinates = function(position) {
                    if (position === undefined) {
                        return $.map(this._coordinates, $.proxy(function(coordinate, index) {
                            return this.coordinates(index);
                        }, this));
                    }

                    let newPosition = position - 1;

                    let coordinate = this._coordinates[newPosition] || 0;

                    const settings = this.settings;
                    let iterator = null;
                    let reciprocalItemsWidth;
                    let elementWidth;

                    if ((settings.autoWidth || settings.merge) && !settings.loop) {
                        iterator = this._items.length;
                        reciprocalItemsWidth = this._items[--iterator].width();
                        elementWidth = this.$element.width();

                        while (iterator--) {
                            reciprocalItemsWidth += this._items[iterator].width();
                            if (reciprocalItemsWidth > elementWidth) {
                                break;
                            }
                        }

                        if (position > iterator && position > 0){
                            let tempPosition = position;

                            reciprocalItemsWidth = 0;
                            while (tempPosition < this._items.length) {
                                reciprocalItemsWidth += this._items[tempPosition++].width();
                            }
                            coordinate = coordinate + 1 * (elementWidth - reciprocalItemsWidth);
                        }
                    }

                    return coordinate = Math.ceil(coordinate);
                }
            }
        });
    }

    function destroyCarousel() {
        related.data('owl.carousel').destroy()
    }
}

module.exports = {
    init: init
};
